<template>
    <div class="row">
        <div class="col-12">
            <h4>Loadbalancing</h4>

            <el-table
            :data="getRedirections"
            style="width: 100%">
                <el-table-column
                    prop="url"
                    label="Url"
                    >
                </el-table-column>
                <el-table-column
                    prop="context"
                    label="Context"
                    >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>


<script>
  import _ from 'underscore';

  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    components: {

    },
    data(){
        return { 
           
        }
    },
    methods: {
     ...mapActions([
            'getRedirectionsAsync',
      ]),
      ...mapMutations(['addAlert']),
    },
    created(){
        this.getRedirectionsAsync()
    },
    computed: {
        ...mapGetters({
            getRedirections: 'getRedirections',
        }),
    }
  };
</script> 

<style lang="scss">


</style>